import { withHoverProps } from '@klarna/higher-order-components'
import PropTypes from 'prop-types'
import * as R from 'ramda'
import React from 'react'
import { Motion, spring } from 'react-motion'

const styles = {
  fill: 'none',
  stroke: '#49494A',
  strokeWidth: 3,
  overflow: 'visible'
}

const hoverStyles = {
  stroke: '#161617',
  cursor: 'pointer'
}

const Chevron = ({ rotated, hover, ...props }) => {
  return (
    <Motion
      defaultStyle={{ scale: 1 }}
      style={{ scale: spring(rotated ? -1 : 1) }}
    >
      {({ scale }) => (
        <svg
          height='5'
          width='10'
          viewBox='0 0 20 10'
          style={{
            ...styles,
            ...(hover && hoverStyles),
            transform: `scale(${scale})`
          }}
          {...props}
        >
          <polyline
            strokeLinecap='round'
            strokeLinejoin='round'
            points='0,0 10,10 20,0'
          />
        </svg>
      )}
    </Motion>
  )
}

Chevron.propTypes = {
  rotated: PropTypes.bool,
  hover: PropTypes.bool
}

export default R.compose(
  withHoverProps({ hover: true })
)(Chevron)

export {
  Chevron
}
